/* eslint-disable no-undef */
/* eslint-disable no-case-declarations */
/* eslint-disable prettier/prettier */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from "react";
import { AllLibs, Docs, Folder, IConfiguration, IListField, IMailData, IReturnFileInsert, ISites, userSKU, } from "./interfaces";
import {
    Breadcrumb, Coachmark, CommandBarButton, DefaultButton, DirectionalHint, FontSizes, FontWeights, IBreadcrumbItem, //IComboBoxOption,
    IDropdownOption, IconButton, Link, MessageBar, MessageBarButton, MessageBarType, Panel, PrimaryButton, Spinner, SpinnerSize, Stack, TeachingBubbleContent, initializeIcons
} from "@fluentui/react";
import { Client } from "@microsoft/microsoft-graph-client";
import { FProperties } from "./FProperties";
//import { getBody } from "../office-document";
// import * as FileSaver from 'file-saver';
// import insertText from "../office-document";
import { configs } from "./Configs";
import { IChannel, IChunk, IFileAttribute, IOneDrive, IReturnedFileDetails, ISDocument, ISEntity, ISMail, ITeams } from "./IEntities";
import { Accordion, AccordionHeader, AccordionItem, AccordionPanel } from "@fluentui/react-components";
import html2pdf from 'html2pdf.js';
import { TeamTag } from "./TeamTag";
import { breadStyles, buttonStyles, ChevronDown, ChevronRight, folderStyles, list, parseDate, stackStyles, theme } from "./Module";
import { ContainedDocs } from "./ContainedDocs";
import { MailsFrom } from "./MailsFrom";
import { Locations } from "./Locations";
import { CheckPlan, saveInList } from "./CodeWrapper";
import { FirstTime } from "./FirstTime";

initializeIcons();
// const csIcon: IIconProps = { iconName: 'Settings' };
// const IconCLose = () => <Icon iconName="ChevronRight" />;


interface MyTree2Props {
    //all: AllLibs[];
    client: Client;
    // eslint-disable-next-line no-undef
    oContext: Office.Context;
    token: string;
}
interface MyTree2State {
    all: AllLibs[];
    panelOpen: boolean;
    eFields: IListField[];
    mbk: string;
    mbkDisplay: boolean;
    showWait: boolean;
    mbMessage: string;
    options: IDropdownOption[];
    docs: IOneDrive[];
    loadSpinner: boolean;
    spninnerId: string;
    teams: ITeams[];
    items: IBreadcrumbItem[];
    isCoachmarkVisible: boolean;
    isFirstTime: number;
    coachmarkPosition: DirectionalHint
    panelTeam: boolean;
    selectedTeam?: ITeams;
    sites?: ISites[];
    panelDocuments: boolean;
    selection: number;
    filesReady?: string;
    isAppFirstTime: boolean;
}




export default class MyTree2 extends React.Component<MyTree2Props, MyTree2State> {

    // protected SaveWhat: { style: string, content: string }[] = [];
    protected _OneDriveSiteID: string;
    protected _OneDriveListName: string;
    private emailAddressFrom: string = '';
    protected _folder: Folder;
    protected _folderOD: IOneDrive;
    protected userOrTag: number;
    protected _doc: Docs;
    protected user: userSKU;
    protected OneDriveName: string = '';
    protected _documentName: string = "";
    protected _siteID: string = "";
    protected _eTag: string;
    protected isList: boolean = false;
    private eFields: IListField[] = [];
    protected _channelID: string;
    protected _url: string = "";
    protected _siteUrl: string;
    protected _urlOD: string = "";

    protected confUrl: string;
    protected confTitle: string;
    protected cmf: boolean = false;
    private entities: ISEntity[] = [];
    private mail: IMailData = { originalSubject: '', subject: '', body: '', attachments: [], sender: '', receiver: '' };
    private mails: IMailData[] = [];
    protected targetButton: any;
    constructor(props: MyTree2Props) {
        super(props);
        this.loadEntities = this.loadEntities.bind(this);
        this.initOneDrive = this.initOneDrive.bind(this);
        this.folderOneDrive = this.folderOneDrive.bind(this);
        this.initSites = this.initSites.bind(this);
        this.sites = this.sites.bind(this);
        this.doActions = this.doActions.bind(this);
        this.onRenderFooterContent = this.onRenderFooterContent.bind(this);
        this.onRenderFooterContentTeams = this.onRenderFooterContentTeams.bind(this);
        this.doActionAttachments = this.doActionAttachments.bind(this);
        this.getBody = this.getBody.bind(this);
        this.onInit2 = this.onInit2.bind(this);
        this.LoadMails = this.LoadMails.bind(this);
        this.Other = this.Other.bind(this);
        this.CreatePdf = this.CreatePdf.bind(this);
        this.saveEml = this.saveEml.bind(this);
        this.loadNav = this.loadNav.bind(this);
        this.createMailFields = this.createMailFields.bind(this);
        this.openPanel = this.openPanel.bind(this);
        this.updateFields = this.updateFields.bind(this);

        configs.WithEntities && this.loadEntities();
        this.state = {
            isAppFirstTime: false,
            selection: 1,
            panelDocuments: false,
            panelTeam: false,
            isFirstTime: 0,
            isCoachmarkVisible: false,
            coachmarkPosition: DirectionalHint.bottomRightEdge, items: [], teams: [], docs: [], loadSpinner: true, spninnerId: 'x1',
            options: [], mbMessage: 'Mail and its contents copied succeffully', all: null, panelOpen: false, eFields: [], mbk: 'none', mbkDisplay: false, showWait: false
        };
        this.targetButton = React.createRef();

    }
    componentDidMount(): void {
        // this.onInit();
        this.onInit2(Office.context);
        this.LoadMails(Office.context);
        this.initOneDrive();
        this.initTeams();
        this.initSites();
        if (localStorage.getItem('AppFirstTime') === null) {
            localStorage.setItem('AppFirstTime', 'No');
            this.setState({ isAppFirstTime: true });
        }
        CheckPlan(this.props.client, Office.context.mailbox.userProfile.emailAddress).
            then((user: userSKU) => {
                this.user = user;
                console.log(this.user);
            })


    }
    private initOneDrive() {

        this.props.client
            .api(`https://graph.microsoft.com/v1.0/me/drive`)
            .get()
            .then((resOneDrive) => {
                const docName = resOneDrive.name == "OneDrive" ? "Documents" : resOneDrive.name;
                this.OneDriveName = docName;
                this.props.client
                    .api(`https://graph.microsoft.com/v1.0/me/drive/root/children?$filter=folder ne null`)
                    .get()
                    .then((response) => {
                        const od: IOneDrive[] = [];

                        this._OneDriveSiteID = response.value[0].parentReference.siteId;
                        this._OneDriveListName = response.value[0].parentReference.name;
                        this._siteID = this._OneDriveSiteID;
                        response.value.map((drive: any) => {
                            od.push({
                                siteID: drive.parentReference.siteId,
                                listName: docName,// drive.parentReference.name,
                                finalpath: "",
                                driverId: drive.parentReference.driveId,
                                id: drive.id,
                                eTag: drive.eTag.split(",")[0].replace(/{/g, "").replace(/}/g, "").replace(/"/g, ""),
                                createdBy: drive.createdBy.user.email,
                                name: drive.name,
                                webUrl: drive.webUrl,
                                open: false,
                                folders: [],
                            });
                        });
                        localStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + 'OD', JSON.stringify(od));
                        this.setState({ docs: od, loadSpinner: false });
                    })
                    .catch(error => {
                        console.log('Error ', `https://graph.microsoft.com/v1.0/me/drive/root/children?$filter=folder ne null`, ' ', error);
                    });


            });

    }
    private folderOneDrive = (o: IOneDrive, docname: string) => {
        let items: IBreadcrumbItem[] = [];
        switch (o.open) {
            case false:
                return (
                    <div key={o.id} style={{ paddingLeft: 15 }} >
                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronRight}
                            width="100%"
                            disabled={false}
                            checked={false}
                            title={o.name}
                            text={o.name.length >= 15 ? o.name.substring(0, 15) + '...' : o.name}
                            onClick={() => {
                                this._urlOD = o.webUrl;
                                this._folderOD = o;
                                this._documentName = o.listName;
                                this._siteID = o.siteID;
                                items = [];
                                const links = o.webUrl.substring(8, o.webUrl.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURIComponent(url),
                                            key: counter.toString(),
                                            onClick: () => { this.confTitle = decodeURIComponent(url); this.confUrl = o.webUrl; this.openPanel(o.siteID, docname); this.isList = false; },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });

                                this.setState({ loadSpinner: true, spninnerId: o.id, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                const folders: IOneDrive[] = [];
                                this.props.client
                                    .api(`https://graph.microsoft.com/v1.0/me/drive/items/${o.id}/children?$filter=folder ne null`)
                                    .get()
                                    .then((response) => {
                                        response.value.map((drive: any) => {
                                            folders.push({
                                                siteID: drive.parentReference.siteId,
                                                finalpath: '',
                                                driverId: drive.parentReference.driveId,
                                                listName: o.listName,
                                                id: drive.id,
                                                eTag: drive.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, ''),
                                                createdBy: drive.createdBy.user.email,
                                                name: drive.name,
                                                webUrl: drive.webUrl,
                                                open: false,
                                                folders: []
                                            });
                                        });
                                        o.folders = folders;
                                        o.open = true;
                                        this.setState({ docs: this.state.docs });
                                    })
                                    .catch(error => {
                                        console.log('Error ', `https://graph.microsoft.com/v1.0/me/drive/items/${o.id}/children?$filter=folder ne null`, ' ', error);
                                    });
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'share' }}
                            title="See The Documents Into The Folder"
                            ariaLabel="See The Documents Into The Folder"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = o.siteID;
                                this._documentName = o.listName;
                                this._eTag = o.eTag;
                                this.setState({ panelDocuments: true });
                            }}
                        />
                        {this.state.loadSpinner && this.state.spninnerId == o.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                    </div>
                );
            case true:
                this._urlOD = o.webUrl;
                return (
                    <div key={o.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            styles={folderStyles}
                            //  menuProps={this.menuItems}
                            iconProps={ChevronDown}
                            width="100%"
                            disabled={false}
                            checked={false}
                            title={o.name}
                            text={o.name.length >= 15 ? o.name.substring(0, 15) + '...' : o.name}
                            onClick={() => {
                                this._urlOD = o.webUrl;
                                this._folderOD = o;
                                this._documentName = o.listName;
                                this._siteID = o.siteID;
                                items = [];
                                const links = o.webUrl.substring(8, o.webUrl.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURIComponent(url),
                                            key: counter.toString(),
                                            onClick: () => { this.confTitle = decodeURIComponent(url); this.confUrl = o.webUrl; this.openPanel(o.siteID, docname); this.isList = false; },// this.openPanel(siteID, docname),
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });
                                const folders: IOneDrive[] = [];
                                switch (o.open) {
                                    case true:
                                        o.open = false;
                                        this.setState({ docs: this.state.docs, loadSpinner: false });
                                        break;
                                    case false:

                                        this.props.client
                                            .api(`https://graph.microsoft.com/v1.0/me/drive/items/${o.id}/children?$filter=folder ne null`)
                                            .get()
                                            .then((response) => {

                                                response.value.map((drive: any) => {
                                                    folders.push({
                                                        listName: o.listName,    //drive.parentReference.driveId,
                                                        siteID: drive.parentReference.siteId,
                                                        finalpath: '',
                                                        driverId: drive.parentReference.driveId,
                                                        id: drive.id,
                                                        eTag: drive.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, ''),
                                                        createdBy: drive.createdBy.user.email,
                                                        name: drive.name,
                                                        webUrl: drive.webUrl,
                                                        open: false,
                                                        folders: []
                                                    });
                                                });
                                                o.folders = folders;
                                                o.open = true;
                                                this.setState({ docs: this.state.docs, items: items, loadSpinner: false, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });

                                            })
                                            .catch(error => {
                                                console.log('Error ', `https://graph.microsoft.com/v1.0/me/drive/items/${o.id}/children?$filter=folder ne null`, ' ', error);
                                            });
                                }
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'share' }}
                            title="See The Documents Into The Folder"
                            ariaLabel="See The Documents Into The Folder"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = o.siteID;
                                this._documentName = o.listName;
                                this._eTag = o.eTag;
                                this.setState({ panelDocuments: true });
                            }}
                        />
                        {o.folders.map((item) => this.folderOneDrive(item, docname))}
                    </div>
                );
        }

    };

    private initTeams() {
        this.props.client
            .api(`https://graph.microsoft.com/v1.0/me/joinedTeams`)
            //   .headers({ "Authorization": `Bearer ${this.props.token}` })
            .get()
            .then((response) => {
                const od: ITeams[] = [];
                response.value.forEach((item: any) => {
                    od.push({
                        siteId: '',
                        id: item.id,
                        displayName: item.displayName,
                        description: item.description,
                        channels: [],
                        open: false
                    });

                });
                localStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + 'OT', JSON.stringify(od));
                this.setState({ teams: od, loadSpinner: false });
            })
            .catch(error => {
                console.log('Error ', `https://graph.microsoft.com/v1.0/me/joinedTeams`, ' ', error);
            });
    }
    private Teams = (o: ITeams) => {
        let items: IBreadcrumbItem[] = [];
        switch (o.open) {
            case false:
                return (
                    <div key={o.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronRight}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={o.displayName}
                            onClick={() => {
                                o.open = !o.open;
                                this.setState({ loadSpinner: true, spninnerId: o.id });
                                this.props.client.api(`https://graph.microsoft.com/v1.0/groups/${o.id}/sites/root`)
                                    .get()
                                    .then((response) => {
                                        o.siteId = response.id;
                                        const siteUrl = response.webUrl;
                                        this.props.client
                                            .api(`https://graph.microsoft.com/v1.0/teams/${o.id}/channels`)
                                            .get()
                                            .then((response) => {
                                                response.value.map((channel: any) => {
                                                    let siteUrl2: string = '';
                                                    switch (channel.membershipType) {
                                                        case "standard":
                                                            siteUrl2 = siteUrl;
                                                            break;
                                                        default:
                                                            siteUrl2 = siteUrl + '-' + channel.displayName;
                                                            break;
                                                    }
                                                    o.channels.push({
                                                        id: channel.id,
                                                        teamId: o.id,
                                                        createdDateTime: channel.createdDateTime,
                                                        displayName: channel.displayName,
                                                        description: channel.description,
                                                        isFavoriteByDefault: channel.isFavoriteByDefault,
                                                        email: channel.email,
                                                        tenantId: channel.tenantId,
                                                        webUrl: siteUrl2,
                                                        membershipType: channel.membershipType,
                                                        isArchived: channel.isArchived,
                                                        open: false,
                                                        driveId: undefined,
                                                        siteId: '',
                                                        folders: []
                                                    });
                                                    const links = siteUrl2.substring(8, siteUrl2.length).split("/");
                                                    let counter = 0;
                                                    links.map((url) => {
                                                        counter > 1 &&
                                                            items.push({
                                                                text: url,
                                                                key: counter.toString(),
                                                                onClick: () => { this.confTitle = url; this.confUrl = siteUrl2; this.openPanel(o.siteId, 'Documents'); this.isList = false; },
                                                                isCurrentItem: counter == links.length ? true : false,
                                                            });
                                                        counter++;
                                                    });

                                                });
                                                this.setState({ teams: this.state.teams, loadSpinner: false });
                                            })
                                            .catch(error => {
                                                console.log('Error ', `https://graph.microsoft.com/v1.0/teams/${o.id}/channels`, ' ', error);
                                            });

                                    })
                                    .catch(error => {
                                        console.log('Error ', `https://graph.microsoft.com/v1.0/groups/${o.id}/sites/root`, ' ', error);
                                    });
                            }}
                        ></CommandBarButton>
                        {this.state.loadSpinner && this.state.spninnerId == o.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                    </div>
                );
            case true:
                return (
                    <div key={o.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            title="Team"
                            styles={folderStyles}
                            //  menuProps={this.menuItems}
                            iconProps={ChevronDown}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={o.displayName}
                            onClick={() => {
                                o.open = false;
                                o.channels = [];
                                items = [];

                                this.setState({ teams: this.state.teams });
                            }}
                        ></CommandBarButton>
                        {this.state.loadSpinner && this.state.spninnerId == o.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                        {o.channels.map((item) => this.Channels(item, o))}
                    </div>
                );
        }
    }
    private Channels = (o: IChannel, t: ITeams) => {
        let items: IBreadcrumbItem[] = [];
        switch (o.open) {
            case false:
                return (
                    <div key={o.id} style={{ paddingLeft: 15, paddingBottom: 2 }}>

                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronRight}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={o.displayName}
                            onClick={() => {
                                this.setState({ loadSpinner: true, spninnerId: o.id });
                                this.props.client
                                    .api(`https://graph.microsoft.com/v1.0/teams/${t.id}/channels/${o.id}/filesFolder`)
                                    .get()
                                    .then((response0: any) => {
                                        o.driveId = response0.parentReference.driveId
                                        o.open = true;
                                        switch (o.membershipType) {
                                            case 'unknownFutureValue':
                                                const url = response0.webUrl;
                                                const hostname = url.match(/https:\/\/([^/]+)/)[1];
                                                const siteName = url.match(/\/sites\/([^/]+)/)[1];
                                                this.props.client
                                                    .api(`https://graph.microsoft.com/v1.0/sites/${hostname}:/sites/${siteName}`)
                                                    .get()
                                                    .then((response1: any) => {
                                                        o.siteId = response1.id.split(',')[1];
                                                        o.folders = [{
                                                            listName: 'Documents',
                                                            siteID: response1.id.split(',')[1],
                                                            id: '',
                                                            driverId: '',
                                                            eTag: '',
                                                            createdBy: '',
                                                            name: 'Documents',
                                                            webUrl: response0.webUrl,
                                                            open: false,
                                                            finalpath: response0.webUrl,
                                                            folders: []
                                                        }];
                                                        this._documentName = 'Documents';
                                                        this.setState({ teams: this.state.teams, items: items, loadSpinner: false, });

                                                    })
                                                    .catch(error => {
                                                        console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${hostname}:/sites/${siteName}`, ' ', error);
                                                    });


                                                break;
                                            default:
                                                this.props.client
                                                    .api(`https://graph.microsoft.com/v1.0/drives/${o.driveId}/root/children`)
                                                    .get()
                                                    .then((response1: any) => {
                                                        items = [];
                                                        response1.value.map((item) => {
                                                            if ((t.channels.find(x => x.displayName === item.name) !== undefined) && (o.displayName === item.name) &&
                                                                (t.channels.find(x => x.displayName === item.name).folders.filter(x1 => x1.name === (item.parentReference.name === 'Shared%20Documents'
                                                                    || item.parentReference.name === 'Shared Documents' ? 'Documents' : item.parentReference.name)).length <= 0)) {
                                                                t.channels.find(x => x.displayName === item.name).folders.push({
                                                                    listName: item.parentReference.name === 'Shared%20Documents' || item.parentReference.name === 'Shared Documents' ? 'Documents' : item.parentReference.name,
                                                                    siteID: item.parentReference.siteId,
                                                                    id: item.parentReference.id,
                                                                    driverId: item.parentReference.driveId,
                                                                    eTag: '',
                                                                    createdBy: '',
                                                                    name: item.parentReference.name === 'Shared%20Documents' || item.parentReference.name === 'Shared Documents' ? 'Documents' : item.parentReference.name,
                                                                    webUrl: item.webUrl.substring(0, item.webUrl.lastIndexOf('/')),
                                                                    open: false,
                                                                    finalpath: item.webUrl.substring(0, item.webUrl.lastIndexOf('/')),
                                                                    folders: []
                                                                });
                                                            }
                                                        });
                                                        items = [];
                                                        this._documentName = 'Documents';
                                                        this.setState({
                                                            teams: this.state.teams, loadSpinner: false, items: items,// isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 

                                                        });
                                                    });
                                        }

                                    })
                                    .catch(error => {
                                        console.log('Error ', `https://graph.microsoft.com/v1.0/teams/${t.id}/channels/${o.id}/filesFolder`, ' ', error);
                                    });
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'Tag' }}
                            title="Send Email To Channels Tags"
                            ariaLabel="Send Email To Channels Tags"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { marginLeft: 30, height: 20, width: 20, backgroundColor: '#FFD09B', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this.userOrTag = 1;
                                this._channelID = o.id;
                                this.setState({ panelTeam: true, selectedTeam: t, mbkDisplay: false });
                            }}
                        />&nbsp;&nbsp;
                        <IconButton
                            iconProps={{ iconName: 'People' }}
                            title="Send Email To Specific Persons"
                            ariaLabel="Send Email To Specific Persons"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { height: 20, width: 20, backgroundColor: '#C1E2A4', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._channelID = o.id;
                                this.userOrTag = 2;
                                this.setState({ panelTeam: true, selectedTeam: t, mbkDisplay: false });
                            }}
                        />
                        {this.state.loadSpinner && this.state.spninnerId == o.id && <Spinner size={SpinnerSize.small} />}
                    </div>
                );
            case true:
                return (
                    <div key={o.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronDown}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={o.displayName}
                            onContextMenu={() => {

                            }}
                            onClick={() => {
                                o.open = false;
                                o.folders = [];
                                items = [];
                                //let counter = 0;
                                this._documentName = 'Documents';
                                this.setState({ teams: this.state.teams, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'Tag' }}
                            title="Send Email To Channel Tags"
                            ariaLabel="Send Email To Channel Tags"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { marginLeft: 30, height: 20, width: 20, backgroundColor: '#FFD09B', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this.userOrTag = 1;
                                this._channelID = o.id;
                                this.setState({ panelTeam: true, selectedTeam: t, mbkDisplay: false });
                            }}
                        />&nbsp;&nbsp;
                        <IconButton
                            iconProps={{ iconName: 'People' }}
                            title="Send Email To Specific Persons"
                            ariaLabel="Send Email To Specific Persons"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { height: 20, width: 20, backgroundColor: '#C1E2A4', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this.userOrTag = 2;
                                this._channelID = o.id;
                                this.setState({ panelTeam: true, selectedTeam: t, mbkDisplay: false });
                            }}
                        />
                        {o.folders !== undefined && o.folders.length > 0 && o.folders.map((item) => this.documents(item, o))}
                    </div>
                );
        }
    }
    private documents = (d: IOneDrive, c: IChannel) => {
        let items: IBreadcrumbItem[] = [];
        switch (d.open) {
            case false:
                return (
                    <div key={d.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            iconProps={ChevronRight}
                            styles={folderStyles}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={d.name}
                            onClick={() => {
                                this._documentName = d.name;
                                this._siteID = d.siteID;
                                items = [];
                                const links = d.finalpath.substring(8, d.finalpath.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURIComponent(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                // this.onInit();
                                                this.isList = false;
                                                this.confTitle = decodeURIComponent(url); this.confUrl = d.finalpath;
                                                this.onInit2(Office.context);
                                                this.openPanel(d.siteID, d.name);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });
                                const docname = d.name === 'Shared%20Documents' || d.name === 'Shared Documents' ? 'Documents' : d.name;
                                this.props.client
                                    .api(`/sites/${d.siteID}/lists/${docname}/drive/root/children`)
                                    .filter("Folder ne null")
                                    .get()
                                    .then((response) => {
                                        response.value.map((folder) => {
                                            c.displayName === folder.name &&
                                                d.folders.filter(x => x.name === folder.name).length <= 0 &&
                                                d.folders.push({
                                                    id: folder.id,
                                                    open: false,
                                                    name: folder.name,
                                                    folders: [],
                                                    listName: d.name,
                                                    siteID: d.siteID,
                                                    driverId: folder.driveId,
                                                    eTag: folder.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, ''),
                                                    createdBy: folder.createdBy,
                                                    webUrl: folder.webUrl,
                                                    finalpath: folder.webUrl
                                                });
                                        });
                                        d.open = true;
                                        this.setState({ all: this.state.all, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                    })
                                    .catch(error => {
                                        console.log('Error ', `/sites/${d.siteID}/lists/${docname}/drive/root/children`, ' ', error);
                                    });

                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'Share' }}
                            title="See The Documents Into The Folder"
                            ariaLabel="See The Documents Into The Folder"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = d.siteID
                                this._documentName = d.listName
                                this._eTag = d.eTag
                                this.setState({ panelDocuments: true });
                            }}
                        />
                    </div>
                );
            case true:
                return (
                    <div key={d.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            iconProps={ChevronDown}
                            styles={folderStyles}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={d.name}
                            onClick={() => {
                                this._documentName = d.name;
                                this._siteID = d.siteID;
                                items = [];
                                const links = d.finalpath.substring(8, d.finalpath.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURIComponent(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                //  this.onInit();
                                                this.isList = false;
                                                this.confTitle = decodeURIComponent(url); this.confUrl = d.finalpath;
                                                this.onInit2(Office.context);
                                                this.openPanel(d.siteID, d.name);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });

                                switch (d.open) {
                                    case true:
                                        d.open = false;
                                        this.setState({ all: this.state.all });
                                        break;
                                    case false:
                                        this.props.client
                                            .api(`/sites/${d.siteID}/lists/${d.name}/drive/root/children`)
                                            .filter("Folder ne null")
                                            .get()
                                            .then((response) => {
                                                //  let key: number = 0;
                                                response.value.map((folder) => {
                                                    d.folders.push({
                                                        id: folder.id,
                                                        open: false,
                                                        name: folder.name,
                                                        folders: [],
                                                        listName: d.name,
                                                        siteID: d.siteID,
                                                        driverId: folder.driveId,
                                                        eTag: folder.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, ''),
                                                        createdBy: folder.createdBy,
                                                        webUrl: folder.webUrl,
                                                        finalpath: folder.webUrl
                                                    });
                                                });
                                                d.open = true;
                                                this.setState({ all: this.state.all, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                            })
                                            .catch(error => {
                                                console.log('Error ', `/sites/${d.siteID}/lists/${d.name}/drive/root/children`, ' ', error);
                                            });
                                }
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'Share' }}
                            title="See The Documents Into The Folder"
                            ariaLabel="See The Documents Into The Folder"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = d.siteID
                                this._documentName = d.listName
                                this._eTag = d.eTag

                                this.setState({ panelDocuments: true });
                            }}
                        />
                        {d.folders.map((item) => this.channelFolders(item, c))}
                    </div>
                );
        }
    };
    private channelFolders = (o: IOneDrive, c: IChannel) => {
        let items: IBreadcrumbItem[] = [];
        switch (o.open) {
            case false:
                return (
                    <div key={o.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronRight}
                            width="100%"
                            disabled={false}
                            checked={false}
                            title={o.name}
                            text={o.name.length >= 15 ? o.name.substring(0, 15) + '...' : o.name}
                            onClick={() => {
                                o.open = true;
                                items = [];
                                const links = o.webUrl.substring(8, o.webUrl.length).split("/");
                                let counter = 0;
                                this._documentName = o.listName;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURIComponent(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                // this.onInit();
                                                this.isList = false;
                                                this.confTitle = decodeURIComponent(url); this.confUrl = o.webUrl;
                                                this.onInit2(Office.context);
                                                this.openPanel(o.siteID, o.listName);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });
                                const docname = o.listName === 'Shared%20Documents' || o.listName === 'Shared Documents' ? 'Documents' : o.listName;
                                this.props.client
                                    .api(`/sites/${o.siteID}/lists/${docname}/drive/items/${o.id}/children`)
                                    .filter("Folder ne null")
                                    .get()
                                    .then((response) => {
                                        response.value.map((folder: any) => {
                                            const etag = folder.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '')
                                            o.folders.filter(x => x.eTag === etag).length <= 0 &&
                                                o.folders.push({
                                                    listName: o.listName,
                                                    siteID: o.siteID,
                                                    id: folder.id,
                                                    driverId: o.driverId,
                                                    eTag: folder.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, ''),
                                                    createdBy: folder.createdDateTime,
                                                    name: folder.name,
                                                    webUrl: folder.webUrl,
                                                    open: false,
                                                    finalpath: '',// folder.parentReference.sharepointIds.siteUrl != null && folder.parentReference.sharepointIds.siteUrl != undefined ? folder.parentReference.sharepointIds.siteUrl : '',
                                                    folders: []
                                                });
                                        });
                                        this.setState({ teams: this.state.teams, loadSpinner: false, items: items });
                                    })
                                    .catch(error => {
                                        console.log('Error ', `/sites/${o.siteID}/lists/${docname}/drive/items/${o.id}/children`, ' ', error);
                                    });
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'Share' }}
                            title="Emoji"
                            ariaLabel="Emoji"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = o.siteID
                                this._documentName = o.listName
                                this._eTag = o.eTag
                                this.setState({ panelDocuments: true });
                            }}
                        />
                        {this.state.loadSpinner && this.state.spninnerId == o.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                    </div>
                );
            case true:
                return (
                    <div key={o.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            styles={folderStyles}
                            //  menuProps={this.menuItems}
                            iconProps={ChevronDown}
                            width="100%"
                            disabled={false}
                            checked={false}
                            title={o.name}
                            text={o.name.length >= 15 ? o.name.substring(0, 15) + '...' : o.name}
                            onClick={() => {
                                o.open = false;
                                o.folders = [];
                                items = [];
                                const links = o.webUrl.substring(8, o.webUrl.length).split("/");
                                let counter = 0;
                                this._documentName = o.listName;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURIComponent(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                this.isList = false;
                                                this.confTitle = decodeURIComponent(url); this.confUrl = o.webUrl;
                                                this.onInit2(Office.context);
                                                this.openPanel(o.siteID, o.listName);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });
                                this.setState({ teams: this.state.teams, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'Share' }}
                            title="Emoji"
                            ariaLabel="Emoji"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = o.siteID
                                this._documentName = o.listName
                                this._eTag = o.eTag

                                this.setState({ panelDocuments: true });
                            }}
                        />
                        {o.folders.map((item) => this.channelFolders(item, c))}
                    </div>
                );
        }
    }

    private onInit2(o: Office.Context) {
        const options: IDropdownOption[] = [];
        if (o.mailbox.item != undefined) {
            o.mailbox.item.attachments.map((item) => {
                options.push({ key: item.name, text: item.name });
            })
            this.LoadMails(o);
        }
        o.mailbox.addHandlerAsync(Office.EventType.ItemChanged, async () => {
            this.mails = [];
            this.LoadMails(o);
        });
        o.mailbox.addHandlerAsync(Office.EventType.SelectedItemsChanged, this.Other, asyncResult => {
            console.log('AsyncResult', o.mailbox.item.from.displayName);
            if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                console.log(asyncResult.error.message);
                return;
            }

            console.log("Event handler added.");
        });
        this.setState({ options: options });
    }

    protected CreatePdf(mailID: string, body: string): Promise<Blob> {

        const options = {
            margin: [20, 20, 20, 20], // top, right, bottom, left
            filename: 'OriginalMail.pdf',
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };
        return new Promise((resolve, reject) => {
            html2pdf()
                .from(body)
                .set(options)
                .toPdf()
                .output('blob')
                .then((pdfAsString) => {
                    const mail = this.mails.find(x => x.id === mailID);
                    if (mail) {
                        mail.bodyBlob = pdfAsString;
                    }
                    resolve(pdfAsString);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    private LoadMails(o: Office.Context) {

        const convertEwsIdToRestId = (ewsId) => {
            const restId = Office.context.mailbox.convertToRestId(ewsId, Office.MailboxEnums.RestVersion.v2_0);
            return restId;
        }

        o.mailbox.item !== null && o.mailbox.getSelectedItemsAsync(async (asyncResult: Office.AsyncResult<Office.SelectedItemDetails[]>) => {
            if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                const selectedItems = asyncResult.value;

                selectedItems.map(async (item) => {

                    const id = convertEwsIdToRestId(item.itemId);
                    if (this.mails.filter(x => x.id === id).length <= 0)

                        await this.props.client
                            .api(`https://graph.microsoft.com/v1.0/me/messages/${id}`)
                            .get()
                            .then(async (res) => {
                                let subject = res.from.emailAddress.name + "-" + res.subject + "-" + res.receivedDateTime.toLocaleString();
                                //     res.subject.substring(0, res.subject.length > 70 ? 70 : res.subject.length).replaceAll(":", " ") + "." +
                                //     res.receivedDateTime.toLocaleString().replaceAll(":", "-").replace(/[&\\/\\#+()$~%.'":*?<>{}]/g, '');
                                // subject = subject.replace(/[&\\/\\#+()$~%.'":*?<>{}]/g, '-');

                                const mail: IMailData = {
                                    originalSubject: res.subject,
                                    subject: subject.replace(/[^\p{L}\p{N}. -]+/gu, ''),
                                    sender: res.sender.emailAddress.address,
                                    body: res.body.content,
                                    id: res.id,
                                    attachments: [],
                                    receiver: res.toRecipients.map(item => item.emailAddress.address).join(',')
                                }
                                await this.props.client
                                    .api(`https://graph.microsoft.com/v1.0/me/messages/${id}/attachments`)
                                    .get()
                                    .then((res) => {
                                        res.value.map((item) => {
                                            if (item.contentBytes !== undefined) {
                                                const b = atob(item.contentBytes);   //btoa atob
                                                var buffer = new ArrayBuffer(b.length);
                                                var view = new Uint8Array(buffer);
                                                for (var i = 0; i < b.length; i++) {
                                                    view[i] = b.charCodeAt(i);
                                                }
                                                const blob = new Blob([view], { type: `${item.contentType}` });
                                                mail.attachments.push({ fileName: item.name, byteArray: blob, contentType: item.contentType, contentLength: item.size as number });
                                            }

                                        });
                                        if (this.mails.filter(x => x.id === id).length <= 0) {
                                            console.log('subject ', mail.subject);
                                            this.mails.push(mail);
                                        }
                                        this.setState({ filesReady: `${this.mails.length} Mail(s) ready to go` })
                                    });
                            })
                            .catch(error => {
                                console.log("error in gettimng mail ", error);
                            });
                });
            }
        });

    }
    private Other() {
        this.mails = [];
        this.LoadMails(Office.context);
    }

    private loadEntities() {
        let files: IReturnedFileDetails[] = [];
        this.props.client
            .api(`/me/drive/root:/ENTITIES:/children`)
            .get()
            .then(response => {
                files = response.value.map((item: IReturnedFileDetails) => ({ context: "", downloadUrl: item.webUrl, createdDateTime: item.createdDateTime, eTag: item.eTag, id: item.id, lastModifiedDateTime: item.lastModifiedDateTime, name: item.name, webUrl: item.webUrl, cTag: '', size: item.size, createdBy: item.createdBy, lastModifiedBy: item.lastModifiedBy, parentReference: item.parentReference, file: item.file, fileSystemInfo: item.fileSystemInfo, shared: {} }));
                const promises = files.map(async (file: { eTag: string; }) => {
                    const id = file.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '')
                    return await this.props.client
                        .api(`/me/drive/items/${id}/content`)
                        .get()
                        .then((response) => {
                            this.entities.push(response);
                        });
                });
                Promise.all(promises)
                    .then(() => {
                        this.entities.map(entity => {
                            entity.Id = files.filter(x => x.name.split('.')[0].toLowerCase() === entity.Header.toLowerCase())[0].eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');
                        });
                    });
            })
            .catch(error => {
                console.log('Error ', `/me/drive/root:/ENTITIES:/children`, ' ', error);
            });

    }
    private getBody(asyncResult) {
        this.mail.body = asyncResult.value;
    }
    private openPanel = (siteId: string, documentName: string) => {
        this._siteID = siteId;
        this.props.client
            .api(`sites/${siteId}/lists/${documentName}?$expand=columns`)
            .get()
            .then((response) => {
                let Id: string;
                let InternalName: string;
                let LookupField: string;
                let LookupList: string;
                let LookupWebId: string;
                let PrimaryFieldId: string;
                let StaticName: string;
                let Title: string;
                let TypeAsString: string;
                let TypeDisplayName: string;
                let ListId: string;
                let CanBeDeleted: boolean;
                let Choises: string[] = [];
                let MaximumValue: number;
                let MinimumValue: number;
                let allowMultipleSelection: boolean = false;
                this.eFields = [];
                let TermGuidId: string;
                response.columns.map((field) => {
                    if (
                        !field.name.startsWith("_") &&
                        field.name !== "AppAuthor" &&
                        field.name !== "Created" &&
                        field.name !== "Color Tag" &&
                        field.name !== "Author" &&
                        field.name !== "ComplianceAssetId" &&
                        field.name !== "_ip_UnifiedCompliancePolicyProperties" &&
                        field.name !== "ContentType" &&
                        field.name !== "Author" &&
                        field.name !== "Modified" &&
                        field.name !== "Editor" &&
                        field.name !== "_CopySource" &&
                        field.name !== "CheckoutUser" &&
                        field.name !== "_CheckinComment" &&
                        field.name !== "LinkFilenameNoMenu" &&
                        field.name !== "LinkFilename" &&
                        field.name !== "ItemChildCount" &&
                        field.name !== "FolderChildCount" &&
                        field.name !== "_ComplianceFlags" &&
                        field.name !== "_ComplianceTag" &&
                        field.name !== "_ComplianceTagWrittenTime" &&
                        field.name !== "_ComplianceTagUserId" &&
                        field.name !== "_IsRecord" &&
                        field.name !== "_CommentCount" &&
                        field.name !== "_LikeCount" &&
                        field.name !== "_DisplayName" &&
                        field.name !== "AppAuthor" &&
                        field.name !== "AppEditor" &&
                        field.name !== "Edit" &&
                        field.name !== "ParentVersionString" &&
                        field.name !== "AppEditor" &&
                        field.name !== "ItemChildCount" &&
                        field.name !== "Item Child Count" &&
                        field.name !== "Checked Out To" &&
                        field.name !== "Label applied by" &&
                        field.name !== "Retention label Applied" &&
                        field.name !== "Retention label" &&
                        field.name !== "Check In Comment" &&
                        field.name !== "Folder Child Count" &&
                        field.name !== "FolderChildCount" &&
                        field.name !== "ParentVersionString" &&
                        field.name !== "ParentLeafName" &&
                        field.name !== "Label setting"
                    ) {
                        Id = field.id;
                        PrimaryFieldId = field.id;
                        InternalName = field.name;
                        StaticName = field.name;
                        Title = field.displayName;
                        CanBeDeleted = !field.readOnly;
                        for (let prop in field) {
                            switch (prop) {
                                case "text":
                                    TypeAsString = "Text";
                                    TypeDisplayName = "Text";
                                    break;
                                case "dateTime":
                                    TypeAsString = "DateTime";
                                    TypeDisplayName = "DateTime";
                                    break;
                                case "boolean":
                                    TypeAsString = "Boolean";
                                    TypeDisplayName = "Boolean";
                                    break;
                                case "choice":
                                    TypeAsString = "Choice";
                                    TypeDisplayName = "Choice";
                                    field.choice.choices.map((s) => Choises.push(s));
                                    break;
                                case "lookup":
                                    TypeAsString = "Lookup";
                                    TypeDisplayName = "Lookup";
                                    LookupList = field.lookup.listId;
                                    LookupField = field.lookup.columnName;
                                    break;
                                case "personOrGroup":
                                    TypeAsString = "Person";
                                    TypeDisplayName = "Person";
                                    allowMultipleSelection = field.personOrGroup.allowMultipleSelection;
                                    break;
                                case "number":
                                    TypeAsString = "Number";
                                    TypeDisplayName = "Number";
                                    break;
                                case "defaultValue":
                                    const regex = /^(\d+);#[A-Z]+\|[\da-f-]+$/i;
                                    if (regex.test(field.defaultValue.value)) {
                                        TypeAsString = "TaxonomyFieldType";
                                        TypeDisplayName = "TaxonomyFieldType";
                                        TermGuidId = field.defaultValue.value.split('|')[1];
                                    }
                                    break;
                                default:
                                    TypeAsString = "Unknown";
                                    TypeDisplayName = "Unknown";
                                    break;
                            }
                        }
                        this.eFields.push({
                            Id: Id,
                            InternalName: InternalName,
                            LookupField: LookupField,
                            LookupList: LookupList,
                            LookupWebId: LookupWebId,
                            PrimaryFieldId: PrimaryFieldId,
                            StaticName: StaticName,
                            Title: Title,
                            TypeAsString: TypeAsString,
                            TypeDisplayName: TypeDisplayName,
                            ListId: ListId,
                            CanBeDeleted: CanBeDeleted,
                            Choises: Choises,
                            MaximumValue: MaximumValue,
                            MinimumValue: MinimumValue,
                            TermGuidId: TypeAsString,
                            allowMultipleSelection: allowMultipleSelection
                        });
                        Choises = [];
                        LookupList = "";
                    }
                });
                this.setState({ panelOpen: true, eFields: this.eFields, mbkDisplay: false });
            })
            .catch(error => {
                console.log('Error ', `sites/${siteId}/lists/${documentName}?$expand=columns`, ' ', error);
            });
    };

    UNSAFE_componentWillReceiveProps(nextProps: Readonly<MyTree2Props>): void {
        this.onInit2(nextProps.oContext);
    }
    private folder = (o: Folder, siteID: string, docname: string) => {
        let items: IBreadcrumbItem[] = [];
        switch (o.open) {
            case false:
                return (
                    <div key={o.key} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronRight}
                            width="100%"
                            disabled={false}
                            checked={false}
                            title={o.name}
                            text={o.name.length >= 15 ? o.name.substring(0, 15) + '...' : o.name}
                            onClick={() => {
                                this._url = o.folderUrl;
                                this._folder = o;
                                this._siteID = siteID;
                                items = [];
                                const links = o.folderUrl.substring(8, o.folderUrl.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURI(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                this.confTitle = decodeURIComponent(url); this.confUrl = o.folderUrl; this.isList = false;
                                                this.onInit2(Office.context);
                                                this.openPanel(siteID, docname);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });
                                this.setState({ loadSpinner: true, spninnerId: o.id });
                                const folders: Folder[] = [];
                                this.props.client
                                    .api(`/sites/${siteID}/lists/${o.docId}/drive/items/${o.id}/children`)
                                    // .headers({ "Authorization": `Bearer ${this.props.token}` })
                                    .filter("Folder ne null")
                                    .get()
                                    .then((response) => {
                                        let key: number = 0;
                                        response.value.map((folder) => {
                                            folders.push({
                                                key: key.toString(),
                                                id: folder.id,
                                                open: false,
                                                name: folder.name,
                                                folderUrl: folder.webUrl,
                                                folders: [],
                                                docId: o.docId,
                                                eTag: folder.eTag.split(",")[0].replace(/{/g, "").replace(/}/g, "").replace(/"/g, "")
                                            });
                                            key++;
                                        });
                                        o.folders = folders;
                                        o.open = true;
                                        this.setState({ all: this.state.all, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                    })
                                    .catch(error => {
                                        // eslint-disable-next-line no-undef
                                        console.log('Error ', `/sites/${siteID}/lists/${docname}/drive/items/${o.id}/children`, ' ', error);
                                    });
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'TextDocumentShared' }}
                            title="Contained Documents"
                            ariaLabel="Contained Documents"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = siteID
                                this._documentName = docname;
                                this._eTag = o.eTag

                                this.setState({ panelDocuments: true });
                            }}
                        />
                        {this.state.loadSpinner && this.state.spninnerId == o.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                    </div>
                );
            case true:
                this._url = o.folderUrl;
                return (
                    <div key={o.key} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            styles={folderStyles}
                            //  menuProps={this.menuItems}
                            iconProps={ChevronDown}
                            width="100%"
                            disabled={false}
                            checked={false}
                            title={o.name}
                            text={o.name.length >= 15 ? o.name.substring(0, 15) + '...' : o.name}
                            onClick={() => {
                                this._url = o.folderUrl;
                                this._folder = o;
                                this._siteID = siteID;
                                items = [];
                                const links = o.folderUrl.substring(8, o.folderUrl.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURI(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                this.confTitle = decodeURI(url); this.confUrl = o.folderUrl; this.isList = false;
                                                this.onInit2(Office.context);
                                                this.openPanel(siteID, docname);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });

                                const folders: Folder[] = [];
                                switch (o.open) {
                                    case true:
                                        o.open = false;
                                        this.setState({ all: this.state.all, loadSpinner: false });
                                        break;
                                    case false:
                                        this.props.client
                                            .api(`/sites/${siteID}/lists/${o.docId}/drive/items/${o.id}/children`)
                                            //  .headers({ "Authorization": `Bearer ${this.props.token}` })
                                            .filter("Folder ne null")
                                            .get()
                                            .then((response) => {
                                                let key: number = 0;
                                                response.value.map((folder) => {
                                                    folders.push({
                                                        key: key.toString(),
                                                        id: folder.id,
                                                        open: false,
                                                        name: folder.name,
                                                        folderUrl: folder.webUrl,
                                                        folders: [],
                                                        docId: o.docId,
                                                        eTag: folder.eTag.split(",")[0].replace(/{/g, "").replace(/}/g, "").replace(/"/g, ""),
                                                    });
                                                    key++;
                                                });
                                                o.folders = folders;
                                                o.open = true;
                                                this.setState({ all: this.state.all, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                            })
                                            .catch(error => {
                                                console.log('Error ', `/sites/${siteID}/lists/${docname}/drive/items/${o.id}/children`, ' ', error);
                                            });
                                }
                            }}
                        ></CommandBarButton>
                        <IconButton
                            iconProps={{ iconName: 'TextDocumentShared' }}
                            title="Contained Documents"
                            ariaLabel="Contained Documents"
                            disabled={false}
                            checked={false}
                            styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                            onClick={() => {
                                this._siteID = siteID
                                this._documentName = docname;
                                this._eTag = o.eTag
                                this.setState({ panelDocuments: true });
                            }}
                        />
                        {o.folders.map((item) => this.folder(item, siteID, docname))}
                    </div>
                );
        }
    };
    private docs = (d: Docs) => {
        let items: IBreadcrumbItem[] = [];
        switch (d.open) {
            case false:
                return (
                    <div key={d.id} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            iconProps={d.template === 'genericList' ? list : ChevronRight}
                            styles={folderStyles}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={d.docName}
                            onClick={() => {
                                this._doc = d;
                                this._documentName = d.docName;
                                this._siteID = d.siteid;
                                items = [];
                                const links = d.docUrl.substring(8, d.docUrl.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURI(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                this._siteUrl = d.siteUrl;
                                                this.confTitle = decodeURI(url); this.confUrl = d.docUrl; this.isList = false;
                                                this.onInit2(Office.context);
                                                this.openPanel(d.siteid, d.docName);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });
                                const folders: Folder[] = [];
                                if (d.template === 'genericList') {
                                    items = [];
                                    const links = d.docUrl.substring(8, d.docUrl.length).split("/");
                                    let counter = 0;
                                    links.map((url) => {
                                        counter > 1 &&
                                            items.push({
                                                text: decodeURI(url),
                                                key: counter.toString(),
                                                onClick: () => {
                                                    this.isList = true;
                                                    this._siteUrl = d.siteUrl;
                                                    this.confTitle = decodeURIComponent(url); this.confUrl = d.docUrl;
                                                    this.onInit2(Office.context);
                                                    this.openPanel(d.siteid, d.docName);
                                                },
                                                isCurrentItem: counter == links.length ? true : false,
                                            });
                                        counter++;
                                    });
                                    this.setState({ sites: this.state.sites, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                }
                                else {
                                    this.setState({ loadSpinner: true, spninnerId: d.id });
                                    this.props.client
                                        .api(`/sites/${d.siteid}/lists/${d.id}/drive/root/children`)
                                        .filter("Folder ne null")
                                        .get()
                                        .then((response) => {
                                            let key: number = 0;
                                            response.value.map((folder) => {
                                                folders.push({
                                                    key: key.toString(),
                                                    id: folder.id,
                                                    open: false,
                                                    name: folder.name,
                                                    folderUrl: folder.webUrl,
                                                    folders: [],
                                                    docId: d.id,
                                                    eTag: folder.eTag.split(",")[0].replace(/{/g, "").replace(/}/g, "").replace(/"/g, ""),
                                                });
                                                key++;
                                            });
                                            d.folders = folders;
                                            d.open = true;

                                            this.setState({ sites: this.state.sites, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                        })
                                        .catch(error => {
                                            console.log('Error ', `/sites/${d.siteid}/lists/${d.docName}/drive/root/children`, ' ', error);
                                        });
                                }

                            }}
                        ></CommandBarButton>
                        {d.template === 'documentLibrary' &&
                            <IconButton
                                iconProps={{ iconName: 'share' }}
                                title="See The Documents Into The Folder"
                                ariaLabel="See The Documents Into The Folder"
                                disabled={false}
                                checked={false}
                                styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                                onClick={() => {
                                    this._siteID = d.siteid;
                                    this._documentName = d.docName;
                                    this._eTag = '';
                                    this.setState({ panelDocuments: true });
                                }}
                            />
                        }
                        {this.state.loadSpinner && this.state.spninnerId == d.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                    </div>
                );
            case true:
                return (
                    <div key={d.key} style={{ paddingLeft: 15 }}>
                        <CommandBarButton
                            iconProps={ChevronDown}
                            styles={folderStyles}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={d.docName}
                            onClick={() => {
                                this._doc = d;
                                this._documentName = d.docName;
                                this._siteID = d.siteid;
                                items = [];
                                const links = d.docUrl.substring(8, d.docUrl.length).split("/");
                                let counter = 0;
                                links.map((url) => {
                                    counter > 1 &&
                                        items.push({
                                            text: decodeURI(url),
                                            key: counter.toString(),
                                            onClick: () => {
                                                this.isList = false;
                                                this._siteUrl = d.siteUrl;
                                                this.confTitle = decodeURI(url); this.confUrl = d.docUrl;
                                                this.onInit2(Office.context);
                                                this.openPanel(d.siteid, d.docName);
                                            },
                                            isCurrentItem: counter == links.length ? true : false,
                                        });
                                    counter++;
                                });
                                const folders: Folder[] = [];
                                switch (d.open) {
                                    case true:
                                        d.open = false;
                                        this.setState({ all: this.state.all, loadSpinner: false });
                                        break;
                                    case false:
                                        this.props.client
                                            .api(`/sites/${d.siteid}/lists/${d.id}/drive/root/children`)
                                            .filter("Folder ne null")
                                            .get()
                                            .then((response) => {
                                                let key: number = 0;
                                                response.value.map((folder) => {
                                                    folders.push({
                                                        key: key.toString(),
                                                        id: folder.id,
                                                        open: false,
                                                        name: folder.name,
                                                        folderUrl: folder.webUrl,
                                                        folders: [],
                                                        docId: d.id,
                                                        eTag: folder.eTag.split(",")[0].replace(/{/g, "").replace(/}/g, "").replace(/"/g, ""),
                                                    });
                                                    key++;
                                                });

                                                d.folders = folders;
                                                d.open = true;
                                                this.setState({ all: this.state.all, items: items, isCoachmarkVisible: true, isFirstTime: this.state.isFirstTime + 1 });
                                            })
                                            .catch(error => {
                                                console.log('Error ', `/sites/${d.siteid}/lists/${d.docName}/drive/root/children`, ' ', error);
                                            });
                                }
                            }}
                        ></CommandBarButton>
                        {
                            d.template === 'documentLibrary' &&
                            <IconButton
                                iconProps={{ iconName: 'share' }}
                                title="See The Documents Into The Folder"
                                ariaLabel="See The Documents Into The Folder"
                                disabled={false}
                                checked={false}
                                styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { margin: 2, height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}
                                onClick={() => {
                                    this._siteID = d.siteid;
                                    this._documentName = d.docName;
                                    this._eTag = '';
                                    this.setState({ panelDocuments: true });
                                }}
                            />
                        }

                        {d.folders.map((item) => this.folder(item, d.siteid, d.docName))}
                    </div>
                );
        }
    };
    private sites = (o: ISites) => {
        switch (o.open) {
            case false:
                return (
                    <div key={o.id}>
                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronRight}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={o.displayName}
                            onClick={() => {
                                this._siteID = o.id;
                                o.open = !o.open;
                                this.setState({ loadSpinner: true, spninnerId: o.id });
                                this.props.client
                                    .api(`/sites/${o.id}/lists`)
                                    .get()
                                    .then((response) => {
                                        let key = 0;
                                        const docs: Docs[] = response.value.filter(x => !x.list.hidden && (x.list.template === 'genericList' || x.list.template === 'documentLibrary')).map((doc: any) => ({
                                            key: key,
                                            site: o.displayName,
                                            siteid: o.id,
                                            open: false,
                                            id: doc.id,
                                            docName: doc.name == 'Shared%20Documents' || doc.name == 'Shared Documents' ? 'Documents' : doc.name,
                                            docUrl: doc.webUrl,
                                            siteUrl: o.webUrl,
                                            template: doc.list.template
                                        }));
                                        o.Libs = docs;
                                        this.setState({ loadSpinner: false, sites: this.state.sites });
                                    })
                                    .catch(error => {
                                        console.log('Error ', `/sites/${o.id}/drives?$filter=driveType ne 'system'`, ' ', error);
                                    });
                            }}
                        ></CommandBarButton>
                        {this.state.loadSpinner && this.state.spninnerId == o.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                    </div>
                );
            case true:
                return (
                    <div key={o.id}>
                        <CommandBarButton
                            styles={folderStyles}
                            iconProps={ChevronDown}
                            width="100%"
                            disabled={false}
                            checked={false}
                            text={o.displayName}
                            onClick={() => {
                                this._siteID = o.id;
                                o.open = !o.open;
                                this.setState({ sites: this.state.sites });
                            }}
                        ></CommandBarButton>
                        {this.state.loadSpinner && this.state.spninnerId == o.id &&
                            <Spinner size={SpinnerSize.small} />
                        }
                        {o.Libs !== undefined && o.Libs.map((item) => this.docs(item))}
                    </div>
                );
        }
    };
    private initSites() {
        let sitesdata: ISites[] = [];
        this.setState({ loadSpinner: true, spninnerId: 'x3' });
        this.props.client
            .api("/sites?search=*")
            .get()
            .then((response) => {
                if (response.value !== undefined && response.value.length > 0) {
                    sitesdata = response.value.filter(item => 'root' in item).map((o: any) => ({
                        id: o.id.split(",")[1],
                        createdDateTime: o.createdDateTime,
                        description: o.description,
                        displayName: o.displayName,
                        webUrl: o.webUrl,
                        open: false
                    }));

                    localStorage.setItem(Office.context.mailbox.userProfile.emailAddress.toString() + 'OS', JSON.stringify(sitesdata));
                    this.setState({ sites: sitesdata, loadSpinner: false });

                }
                else {
                    //  this.setState({ errorHappened: true });
                }

            })
            .catch(error => {
                // eslint-disable-next-line no-undef
                console.log('Error ', "/sites?search=*", ' ', error);
            });
    }


    private doActions(goTeams: boolean) {
        const linksToTeams: { link: string, name: string, contentType: string, eTag: string }[] = [];
        this.setState({ panelOpen: false, showWait: true });
        let listName: string = '';
        if (this.isList) {
            listName = this._documentName;
            this._documentName = "Documents";
        }
        if (this.mails.length > 0) {
            this.mails.forEach(async (mail) => {
                let isMail: ISMail = { id: '', siteId: '', listId: '', sharedLink: '', Attributes: [], fodlerId: '', fileId: '', dateSend: '', title: '', originalMailUrl: '', folderUrl: '', sender: '', receiver: '', files: [] };

                let finalPath: string = '';
                let nindex = -1;

                if (this._documentName === 'Documents' || this._documentName === 'Shared%20Documents' || this._documentName === 'Shared Documents' || this._documentName == this.OneDriveName) {
                    nindex = this.state.items.findIndex(x => x.text === "Documents" || x.text === "Shared%20Documents" || x.text === 'Shared Documents' || x.text === this.OneDriveName)
                }
                else {
                    if (this.state.items.findIndex(x => x.text == 'Shared Documents') > -1)
                        nindex = this.state.items.findIndex(x => x.text == 'Shared Documents');
                    else nindex = this.state.items.findIndex(x => x.text == this._documentName);
                }

                this.state.items.forEach((item, index) => {
                    if (index >= nindex + 1) {
                        finalPath += item.text + '/';
                    }
                });
                if (this.isList) { finalPath = ""; }
                const body = mail.body;
                this.CreatePdf(mail.id, body).then(async () => {
                    let path: string = '';
                    let subject: string = '';
                    switch (goTeams) {
                        case true:
                            this._siteID = this._OneDriveSiteID;
                            this._documentName = this._OneDriveListName;
                            finalPath = 'Microsoft Teams Chat Files';
                            path = `/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}:/children`;
                            subject = mail.subject + generateGUID();
                            break;
                        case false:
                            if (finalPath.length > 0) {
                                finalPath = finalPath.slice(0, -1);
                                path = `/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}:/children`;
                            }
                            else {
                                path = `/sites/${this._siteID}/lists/${this._documentName}/drive/root/children`;
                            }
                            subject = mail.subject;
                            break;
                    }
                    await this.props.client
                        .api(path)
                        .filter(`Name eq '${subject}'`)
                        .get()
                        .then(async (response) => {
                            if (response.value.length == 0) {
                                await this.props.client
                                    .api(path)
                                    .post({ name: subject, folder: {}, "Content-type": "application/json", })
                                    .then(async (_response) => {
                                        finalPath += "/" + _response.name;
                                        isMail.folderUrl = _response.webUrl;
                                        isMail.fodlerId = _response.parentReference.driveId;
                                        this.saveEml(mail.id, this._siteID, this._documentName, finalPath, linksToTeams, isMail);

                                        if (this.isList)
                                            saveInList(this.mails, this.props.client, listName, this._siteID, isMail.folderUrl, this.cmf, this.state.eFields);
                                        if (mail.bodyBlob.size > 327680) {
                                            await this.props.client
                                                .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}/OriginalMail.pdf:/createUploadSession`)
                                                .headers({ 'Content-Type': 'application/json' })
                                                .post(null)
                                                .then(async (response) => {
                                                    const chunkObj: IChunk = {
                                                        context: response["@odata.context"],
                                                        expirationDateTime: response.expirationDateTime,
                                                        nextExpectedRanges: response.nextExpectedRanges,
                                                        uploadUrl: response.uploadUrl
                                                    };
                                                    const chunksize = 327680;
                                                    let start = 0;
                                                    let end = chunksize - 1;
                                                    // let index = 0;
                                                    let hasErrors = false;
                                                    while (start < mail.bodyBlob.size && !hasErrors) {
                                                        const chunk = mail.bodyBlob.slice(start, end + 1);
                                                        await this.props.client
                                                            .api(`${chunkObj.uploadUrl}`)
                                                            .headers({ 'Content-Range': `bytes ${start}-${end}/${mail.bodyBlob.size}`, 'Content-Length': chunk.size })
                                                            .put(chunk)
                                                            .then((response) => {
                                                                if (response.cTag !== undefined) {
                                                                    start = end + 1;
                                                                    end = Math.min(start + chunksize - 1, mail.bodyBlob.size - 1);
                                                                    this.doActionAttachments(finalPath, response, linksToTeams, goTeams, mail.body, isMail, mail);
                                                                }
                                                                else {
                                                                    start = end + 1;
                                                                    end = Math.min(start + chunksize - 1, mail.bodyBlob.size - 1);
                                                                }
                                                            })
                                                            .catch(err => {
                                                                console.log("error", err);
                                                                hasErrors = true;
                                                            });
                                                    }
                                                })
                                                .catch(error => {
                                                    console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}/OriginalMail.pdf:/createUploadSession`, ' ', error);
                                                });


                                        }///end of big mail body
                                        else
                                            await this.props.client
                                                .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}/OriginalMail.pdf:/content`)
                                                .headers({ 'Content-Type': 'application/pdf', 'Content-Disposition': 'inline' })
                                                .put(mail.bodyBlob)
                                                .then((response) => {
                                                    this.doActionAttachments(finalPath, response, linksToTeams, goTeams, mail.body, isMail, mail);
                                                })
                                                .catch((error) => {
                                                    console.log('error', error);
                                                });

                                    }).catch(() => {
                                        this.setState({ panelOpen: false, mbk: 'error', mbkDisplay: true, showWait: false, mbMessage: 'Mail or Path Already exist' });
                                    });
                            }
                            else {
                                this.setState({ panelOpen: false, mbk: 'error', mbkDisplay: true, showWait: false, mbMessage: 'Mail or Path Already exist' });
                            }
                        })
                        .catch(error => {
                            console.log('Error ', path, ' ', error);
                        });
                });
            });
        }
        else {
            this.setState({ mbk: 'failed', showWait: false, mbkDisplay: true, mbMessage: 'No Mail Selected' });
        }
    }

    protected doActionAttachments(finalPath: string, response: any, linksToTeams: any, goTeams: boolean, body: string, _isMail: ISMail, currentMail: IMailData) {
        let isMail: ISMail = _isMail;
        const myresu: IReturnFileInsert = response;
        const etag = myresu.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');
        if (response["@content.downloadUrl"] !== undefined)
            linksToTeams.push({ link: response["@content.downloadUrl"], name: response.name, contentType: response.file.mimeType, eTag: etag });
        else
            linksToTeams.push({ link: response['@microsoft.graph.downloadUrl'], name: response.name, contentType: response.file.mimeType, eTag: etag });

        isMail.id = myresu.id;
        isMail.fileId = etag;
        isMail.siteId = this._siteID;
        isMail.listId = this._documentName;
        isMail.originalMailUrl = myresu.webUrl;
        // let temp: string = "{";
        const o = JSON.parse(sessionStorage.getItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems"));
        this.updateFields(response, linksToTeams, _isMail)
        // o !== null && o.map((x: any, i: any) => {
        //     if (this.eFields.find(o => o.StaticName == x.key).TypeAsString == "Lookup") {
        //         if (o.length - 1 == i) { temp += "'" + x.key + "LookupId':'" + x.value + "'"; }
        //         else { temp += "'" + x.key + "LookupId':'" + x.value + "',"; }
        //     }
        //     else {
        //         if (o.length - 1 == i) { temp += "'" + x.key + "':'" + x.value + "'"; }
        //         else { temp += "'" + x.key + "':'" + x.value + "',"; }
        //     }
        // });
        // temp += "}";
        // const FA: IFileAttribute[] = this.eFields.map(
        //     (field: any) => (
        //         {
        //             Id: field.Id, docId: field.listId, siteUrl: field.siteUrl,
        //             InternalName: field.InternalName, LookupField: field.LookupField,
        //             LookupList: field.LookupList, LookupWebId: field.LookupWebId,
        //             PrimaryFieldId: field.PrimaryFieldId, StaticName: field.StaticName,
        //             Title: field.Title, TypeAsString: field.TypeAsString, TypeDisplayName: field.TypeDisplayName,
        //             ListId: field.ListId, CanBeDeleted: field.CanBeDeleted,
        //             Choises: field.Choises, MaximumValue: field.MaximumValue, MinimumValue: field.MinimumValue
        //         }));
        // isMail.Attributes = FA;

        // if ((temp.length > 5) && (!this.isList)) {
        //     this.props.client
        //         .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag.split(',')[0]}/fields`)
        //         .patch(temp)
        //         .then(() => {
        //             this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, mbMessage: "Mail and its content copied succefully" });
        //         })
        //         .catch(error => {
        //             console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag.split(',')[0]}/fields`, ' ', error);
        //         });
        // }
        const options: IDropdownOption[] = JSON.parse(window.sessionStorage.getItem(Office.context.mailbox.userProfile.emailAddress.toString() + "Attachments"));
        if (options !== null && options.length > 0) {
            currentMail.attachments = currentMail.attachments.filter((aItem => options.some(bItem => bItem.key === aItem.fileName)));
        }
        const promises = currentMail.attachments.map((attachment) => {
            const filename = attachment.fileName.replace(/[^\p{L}\p{N}. -]+/gu, '');
            if (attachment.byteArray.size > 327680) {

                return this.props.client
                    .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}/${filename}:/createUploadSession`)
                    .headers({ 'Content-Type': 'application/json' })
                    .post(null)
                    .then(async (response) => {
                        const chunkObj: IChunk = {
                            context: response["@odata.context"],
                            expirationDateTime: response.expirationDateTime,
                            nextExpectedRanges: response.nextExpectedRanges,
                            uploadUrl: response.uploadUrl
                        };
                        const chunksize = 327680;
                        let start = 0;
                        let end = chunksize - 1;
                        // let index = 0;
                        let hasErrors = false;
                        while (start < attachment.byteArray.size && !hasErrors) {
                            const chunk = attachment.byteArray.slice(start, end + 1);
                            await this.props.client
                                .api(`${chunkObj.uploadUrl}`)
                                .headers({ 'Content-Range': `bytes ${start}-${end}/${attachment.byteArray.size}`, 'Content-Length': chunk.size })
                                .put(chunk)
                                .then((response) => {
                                    if (response.cTag !== undefined) {
                                        start = end + 1;
                                        end = Math.min(start + chunksize - 1, attachment.byteArray.size - 1);
                                        const myresu2: IReturnFileInsert = response;
                                        const etag2 = myresu2.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');
                                        linksToTeams.push({ link: response['@microsoft.graph.downloadUrl'], name: response.name, contentType: response.file.mimeType, eTag: etag2 });
                                        const file: ISDocument = {
                                            downloadUrl: myresu2.webUrl,
                                            createdDateTime: myresu2.createdDateTime.toString(),
                                            eTag: etag2,
                                            id: myresu2.id,
                                            Size: attachment.contentLength,
                                            SiteID: this._siteID,
                                            ListID: myresu2.parentReference.driveId,
                                            lastModifiedDateTime: myresu2.lastModifiedDateTime.toString(),
                                            lastCheckedDateTime: myresu2.lastModifiedDateTime.toString(),
                                            name: myresu2.name,
                                            webUrl: myresu2.webUrl,
                                            iconName: myresu2.name !== null && myresu2.name !== undefined ? `https://static2.sharepointonline.com/files/fabric/assets/item-types/16/${myresu2.name.split('.').pop()}.svg` : `https://static2.sharepointonline.com/files/fabric/assets/item-types/16/presentation.svg`,
                                            returnFileDetails: null,
                                            Attributes: null,
                                            ServerRedirectedEmbedUri: myresu2.webUrl,
                                            CreatedBy: myresu2.createdBy.user.email,
                                            ModifiedBy: myresu2.lastModifiedBy.user.email,
                                        }
                                        if (isMail.files.filter(x => x.name == myresu2.name).length <= 0) {
                                            isMail.files.filter(x => x.eTag == etag2).length <= 0 && isMail.files.push(file);
                                        }
                                        else {
                                            isMail.files.filter(x => x.name == myresu2.name)[0] = file;
                                        }
                                        let temp2: string = "{";
                                        const o2 = JSON.parse(sessionStorage.getItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems"));
                                        o2 !== null && o2.map((x: any, i: any) => {
                                            if (this.eFields.find(o => o.StaticName == x.key).TypeAsString == "Lookup") {
                                                if (o.length - 1 == i) { temp2 += "'" + x.key + "LookupId':'" + x.value + "'"; }
                                                else { temp2 += "'" + x.key + "LookupId':'" + x.value + "',"; }
                                            }
                                            else {
                                                if (o.length - 1 == i) { temp2 += "'" + x.key + "':'" + x.value + "'"; }
                                                else { temp2 += "'" + x.key + "':'" + x.value + "',"; }
                                            }
                                        });
                                        temp2 += "}";
                                        if ((temp2.length > 5) && (!this.isList)) {
                                            this.props.client
                                                .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag2.split(',')[0]}/fields`)
                                                .patch(temp2)
                                                .then(() => {
                                                    this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, mbMessage: 'Mail and its content copied successfully' });
                                                })
                                                .catch(error => {
                                                    // eslint-disable-next-line no-undef
                                                    console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag2.split(',')[0]}/fields`, ' ', error);
                                                });
                                        }
                                    }
                                    else {
                                        //  index++;
                                        start = end + 1;
                                        end = Math.min(start + chunksize - 1, attachment.byteArray.size - 1);
                                    }
                                })
                                .catch(err => {
                                    console.log("error", err);
                                    hasErrors = true;
                                });
                        }

                    }).catch(err => {
                        console.log("error", err)
                    });
            }
            else {
                return this.props.client
                    .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}/${filename}:/content`)
                    .headers({ 'Content-Length': attachment.contentLength, 'Content-Range': 'bytes 0-' + (attachment.contentLength - 1) + '/' + attachment.contentLength })
                    .put(attachment.byteArray)
                    .then((response) => {

                        const myresu2: IReturnFileInsert = response;
                        const etag2 = myresu2.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');
                        //['@microsoft.graph.downloadUrl']
                        linksToTeams.push({ link: response['@microsoft.graph.downloadUrl'], name: response.name, contentType: response.file.mimeType, eTag: etag2 });
                        const file: ISDocument =
                        {
                            downloadUrl: myresu2.webUrl,
                            createdDateTime: myresu2.createdDateTime.toString(),
                            eTag: etag2,
                            id: myresu2.id,
                            Size: attachment.contentLength,
                            SiteID: this._siteID,
                            ListID: myresu2.parentReference.driveId,
                            lastModifiedDateTime: myresu2.lastModifiedDateTime.toString(),
                            lastCheckedDateTime: myresu2.lastModifiedDateTime.toString(),
                            name: myresu2.name,
                            webUrl: myresu2.webUrl,
                            iconName: myresu2.name !== null && myresu2.name !== undefined ? `https://static2.sharepointonline.com/files/fabric/assets/item-types/16/${myresu2.name.split('.').pop()}.svg` : `https://static2.sharepointonline.com/files/fabric/assets/item-types/16/presentation.svg`,
                            returnFileDetails: null,
                            Attributes: null,
                            ServerRedirectedEmbedUri: myresu2.webUrl,
                            CreatedBy: myresu2.createdBy.user.email,
                            ModifiedBy: myresu2.lastModifiedBy.user.email,
                        }
                        if (isMail.files.filter(x => x.name == myresu2.name).length <= 0) {
                            isMail.files.filter(x => x.eTag == etag2).length <= 0 && isMail.files.push(file);
                        }
                        else {
                            isMail.files.filter(x => x.name == myresu2.name)[0] = file;
                        }
                        let temp2: string = "{";
                        const o2 = JSON.parse(sessionStorage.getItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems"));
                        o2 !== null && o2.map((x: any, i: any) => {
                            if (this.eFields.find(o => o.StaticName == x.key).TypeAsString == "Lookup") {
                                if (o.length - 1 == i) { temp2 += "'" + x.key + "LookupId':'" + x.value + "'"; }
                                else { temp2 += "'" + x.key + "LookupId':'" + x.value + "',"; }
                            }
                            else {
                                if (o.length - 1 == i) { temp2 += "'" + x.key + "':'" + x.value + "'"; }
                                else { temp2 += "'" + x.key + "':'" + x.value + "',"; }
                            }
                        });
                        temp2 += "}";
                        if (temp2.length > 5) {
                            this.props.client
                                .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag2.split(',')[0]}/fields`)
                                .patch(temp2)
                                .then(() => {
                                    this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, mbMessage: 'Mail and its content copied successfully' });
                                })
                                .catch(error => {
                                    // eslint-disable-next-line no-undef
                                    console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag2.split(',')[0]}/fields`, ' ', error);
                                });
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line no-undef
                        console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/drive/root:/${finalPath}/${filename}:/content`, ' ', error);
                    });
            }
        });
        Promise.all(promises)
            .then(() => {
                switch (goTeams) {
                    case true:
                        //////////////////////////////////////////////
                        const linkPromises = linksToTeams.map(async (item) => {
                            return await this.props.client
                                .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${item.eTag}/createLink`)
                                .header("Content-Type", "application/json")
                                .post({ body: JSON.stringify({ "type": "View" }) })
                                .then((res) => {
                                    item.link = res.link.webUrl;
                                    //   console.log('res for link', res);
                                })
                                .catch(error => {
                                    // eslint-disable-next-line no-undef
                                    console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${item.eTag}/createLink`, ' ', error);
                                });
                        });
                        Promise.all(linkPromises)
                            // .then(() => {
                            //     delay(20000).then(() => console.log('5 seconds have passed'));
                            // })
                            .then(() => {
                                delay(20000).then(() => console.log('5 seconds have passed'));
                                const teamTag: { TagId?: string, channelID: string, hasAttach: boolean, message: string, sendTo: string[] } = JSON.parse(sessionStorage.getItem('TeamTag'));
                                let bodyMembers: string = '{"chatType":"group","members": [ ';
                                let counter: number = 1;
                                teamTag.sendTo.map((item) => {
                                    bodyMembers += `{"@odata.type": "#microsoft.graph.aadUserConversationMember","roles": ["owner"], "user@odata.bind": "https://graph.microsoft.com/v1.0/users('${item}')" }${counter < teamTag.sendTo.length ? ',' : ''}`;
                                    counter++;
                                });
                                bodyMembers += ' ] }';
                                this.props.client
                                    .api(`https://graph.microsoft.com/v1.0/chats`)
                                    .header("Content-Type", "application/json")
                                    .post(bodyMembers)
                                    .then((response) => {
                                        const chatId = response.id;
                                        const attachments: any[] = [];

                                        let atstr: string = '';
                                        linksToTeams.filter(x => x.link !== undefined).forEach((item) => {
                                            atstr += `<attachment Id="${item.eTag}"></attachment>`;
                                            attachments.push({
                                                id: `${item.eTag}`,
                                                contentType: "reference",
                                                contentUrl: `${item.link}`,
                                                name: `${item.name}`,
                                                // thumbnailUrl: `${item.link}`,
                                                //  providerType:"OneDriveBusiness",
                                                //  previewUrl: `${item.link}`
                                            });
                                        });
                                        body = `<div><b>${teamTag.message}</b><br/><br/></div>` + body;
                                        //  body = '<html><body>skata </body></html>'
                                        let position = body.indexOf('</body>');
                                        if (teamTag.hasAttach) {
                                            body = body.slice(0, position) + atstr + ' ' + body.slice(position);
                                        }


                                        // body += atstr;

                                        const _body = {
                                            subject: currentMail.subject,
                                            body: {
                                                contentType: "html",
                                                content: body
                                            },
                                            attachments: []
                                        };
                                        if (teamTag.hasAttach) { _body.attachments = attachments; }
                                        this.props.client
                                            .api(`https://graph.microsoft.com/v1.0/chats/${chatId}/messages`)
                                            .headers({ 'Content-Type': 'application/json' })
                                            .post(JSON.stringify(_body)

                                            )
                                            .then((response) => {
                                                console.log('chat ', response)
                                                this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, showWait: false, mbMessage: 'Mail and its content sent successfully to teams' });
                                            })
                                            .catch(() => {
                                                const links = attachments.map((item) => (`<div> <a href="${item.contentUrl}">${item.name}</a></div><br>`));

                                                let _bd = `<html><body><div><b>${teamTag.message}</b><br/><br/></div>
                                                <div style="color:red">PSShareEmail: Due to Teams size limitations cannot send you the mail as is but you can get it using the following links</div><br> ${links} </body></html>`;


                                                const _bodyError = {
                                                    subject: currentMail.subject,
                                                    body: {
                                                        contentType: "html",
                                                        content: _bd
                                                    },
                                                    attachments: []
                                                };



                                                this.props.client
                                                    .api(`https://graph.microsoft.com/v1.0/chats/${chatId}/messages`)
                                                    .headers({ 'Content-Type': 'application/json' })
                                                    .post(JSON.stringify(_bodyError)

                                                    )
                                                    .then(() => {
                                                        this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, showWait: false, mbMessage: 'Mail and its content sent successfully to teams' });
                                                    })
                                                    .catch(error => {
                                                        // eslint-disable-next-line no-undef
                                                        console.log('Error ', `https://graph.microsoft.com/v1.0/chats/${chatId}/messages`, ' ', error);
                                                    });

                                            });

                                    })
                                    .catch(error => {
                                        // eslint-disable-next-line no-undef
                                        console.log('Error ', `https://graph.microsoft.com/v1.0/chats`, ' ', error);
                                    });
                            })
                            .catch(error => {
                                // eslint-disable-next-line no-undef
                                console.log('Error ', error);
                            });



                        break;
                    case false:

                        // this.props.client
                        //     .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/drive/items/${this.isMail.id}/createLink`)
                        //     .header("Content-Type", "application/json")
                        //     .post({ type: "View" })
                        //     .then((response) => {
                        //         this.isMail.sharedLink = response.link.webUrl;
                        //         const eo: IComboBoxOption[] = JSON.parse(sessionStorage.getItem('selectedEntities'));
                        //         const entity: ISEntity = this.entities.filter(x => x.Id == eo.filter(xx => xx.selected == true)[0].key)[0];
                        //         if (entity != undefined && entity !== null) {
                        //             entity.Mails.push(this.isMail);
                        //             sessionStorage.setItem('Entity', JSON.stringify(entity));
                        //             configs.WithEntities && this.findAndSaveEntityonSP(entity, this._siteID, Office.context.mailbox.userProfile.emailAddress);

                        //             configs.WithEntities && this.props.client
                        //                 .api(`https://graph.microsoft.com/v1.0/me/drive/root:/ENTITIES/${entity.Header}.json:/content`)
                        //                 .headers({ 'Content-Type': 'text/json' })
                        //                 .put(sessionStorage.getItem('Entity'))
                        //                 .then(() => {
                        //                     //  console.log("after update entity", response);
                        //                     this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, showWait: false, mbMessage: 'Mail and its content copied successfully' });
                        //                 }).catch(err => {
                        //                     console.log("error", err)
                        //                 });
                        //         }
                        //     }
                        //     );
                        break;
                }


            });
        switch (goTeams) {
            case true:
                this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, showWait: false, mbMessage: 'Mail send to selected users' });
                break;
            case false:

                this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, showWait: false, mbMessage: 'Mail copied successfully' });
        }
    }
    // private findAndSaveEntityonSP(entity: ISEntity, _siteId: string, _userEmail: string) {
    //     console.log("Entity is", entity);
    //     this.props.client
    //         .api(`https://graph.microsoft.com/v1.0/sites/${configs.alertSiteID}/lists/User Information List/items?$filter=fields/EMail eq '${_userEmail}'&$select=id,name,description,fields`)
    //         .header("Prefer", "HonorNonIndexedQueriesWarningMayFailRandomly")
    //         .get()
    //         .then((response) => {
    //             const userid = response.value.lastItem.id;
    //             console.log("response from findAndSaveEntityonSP", response, response.value.lastItem.id);

    //             this.props.client
    //                 .api(`https://graph.microsoft.com/v1.0/sites/${configs.alertSiteID}/lists/alerts/items?$filter=(fields/Title eq '${entity.Header}')  and (fields/AuthorId eq ${userid})&$expand=fields`)
    //                 .header("Prefer", "HonorNonIndexedQueriesWarningMayFailRandomly")
    //                 .get()
    //                 .then((response) => {
    //                     console.log("Response", response);
    //                     const oldJson = response.value[0].fields.oldjson !== undefined ? response.value[0].fields.oldjson : '';
    //                     const newJson = response.value[0].fields.newjson !== undefined ? response.value[0].fields.newjson : '';
    //                     const eTag = response.value[0].eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');

    //                     console.log("oldJSON", oldJson);
    //                     this.props.client
    //                         .api(`https://graph.microsoft.com/v1.0/sites/${configs.alertSiteID}/lists/alerts/items/${eTag}/fields`)
    //                         .patch(JSON.stringify({ "oldjson": JSON.stringify(newJson !== "" ? newJson : oldJson !== "" ? oldJson : entity), "newjson": JSON.stringify(entity), "LastInsertedFile": new Date().toISOString() }))
    //                         .then((_response) => {
    //                             console.log("response", _response);
    //                             //   this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, mbMessage: 'Mail and its content copied successfully' });
    //                         });
    //                 });
    //         });
    // }
    private onRenderFooterContent = (): JSX.Element => {
        return (
            <div>
                <PrimaryButton onClick={() => {
                    this.doActions(false);
                }} styles={buttonStyles}>Save</PrimaryButton>
                <DefaultButton onClick={() => this.setState({ panelOpen: false })}>Cancel</DefaultButton>
            </div>
        );
    };
    private onRenderFooterContentTeams = (): JSX.Element => {
        return (
            <div>
                <PrimaryButton onClick={() => {

                    this.setState({ panelTeam: false, mbk: 'Wait', mbMessage: 'Please do not close this window. Sending Mail to users' });
                    //  const teamObj: { TagId?: string, channelID: string, hasAttach: boolean, message: string, sendTo: string[] } = sessionStorage.getItem('TeamTag');
                    this.doActions(true);
                }} styles={buttonStyles}>Save</PrimaryButton>
                <DefaultButton onClick={() => this.setState({ panelTeam: false })}>Cancel</DefaultButton>
            </div>
        );
    };
    private onRenderFooterContentDocuments = (): JSX.Element => {
        return (
            <div>
                <PrimaryButton onClick={() => {

                    this.setState({ panelDocuments: false });

                }} styles={buttonStyles}>Close</PrimaryButton>
            </div>
        );
    };
    private preview(url): void {
        if (Office.context.diagnostics.platform === Office.PlatformType.OfficeOnline) {
            window.open(url, '_blank');
        }
        else
            Office.context.ui.openBrowserWindow(url);
    }
    private saveEml(itemId: string, siteID: string, list: string, path: string, linksToTeams: any, _isMail: ISMail): void {
        if (localStorage.getItem('outConfig') != null) {
            const conf = JSON.parse(localStorage.getItem('outConfig'));
            if (conf.recents !== undefined) {
                conf.recents.push({ siteid: siteID, listid: list, path: this.confUrl, title: this._documentName, saved: new Date().toLocaleString('el-GR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false, }) });
                const sortedItems = conf.recents.filter(x => x.saved !== undefined).sort((a, b) => parseDate(b.saved).getTime() - parseDate(a.saved).getTime());
                conf.recents = sortedItems.slice(0, 10);
                localStorage.setItem('outConfig', JSON.stringify(conf));
            } else {
                conf.recents = [{ siteid: siteID, listid: list, path: this.confUrl, title: this._documentName, saved: new Date().toLocaleString('el-GR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false, }) }];
                localStorage.setItem('outConfig', JSON.stringify(conf));
            }
        } else {
            let conf: IConfiguration = { locations: [], recents: [] };

            conf.recents.push({ siteid: siteID, listid: list, path: this.confUrl, title: this._documentName, saved: new Date().toLocaleString('el-GR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false, }) });
            localStorage.setItem('outConfig', JSON.stringify(conf));
        }

        this.props.client
            .api(`https://graph.microsoft.com/v1.0/me/messages/${itemId}/$value`)
            .headers({ 'Accept': 'application/octet-stream' })
            .get()
            .then((response) => {
                const mimeContent = new Blob([response], { type: 'message/rfc822' });
                this.props.client
                    .api(`https://graph.microsoft.com/v1.0/sites/${siteID}/lists/${list}/drive/root:/${path}/mail.eml:/content`)
                    .headers({ 'Content-Type': 'application/json' })
                    .put(mimeContent)
                    .then((response) => {
                        this.updateFields(response, linksToTeams, _isMail);
                        //  console.log('After Save Eml ', response);
                        //  this.doActionAttachments(finalPath, response, linksToTeams, goTeams, mail.body, isMail, mail);
                    })
                    .catch((error) => {
                        console.log('error', error);
                    });
            })
            .catch((error) => {
                console.log('error', error);
            });

    }
    private updateFields(response: any, linksToTeams: any, _isMail: ISMail): void {
        let isMail: ISMail = _isMail;
        const myresu: IReturnFileInsert = response;
        const etag = myresu.eTag.split(',')[0].replace(/{/g, '').replace(/}/g, '').replace(/"/g, '');
        if (response["@content.downloadUrl"] !== undefined)
            linksToTeams.push({ link: response["@content.downloadUrl"], name: response.name, contentType: response.file.mimeType, eTag: etag });
        else
            linksToTeams.push({ link: response['@microsoft.graph.downloadUrl'], name: response.name, contentType: response.file.mimeType, eTag: etag });

        isMail.id = myresu.id;
        isMail.fileId = etag;
        isMail.siteId = this._siteID;
        isMail.listId = this._documentName;
        isMail.originalMailUrl = myresu.webUrl;
        let temp: string = "{";
        const o = JSON.parse(sessionStorage.getItem(Office.context.mailbox.userProfile.emailAddress.toString() + "ChangedItems"));
        o !== null && o.map((x: any, i: any) => {
            if (this.eFields.find(o => o.StaticName == x.key).TypeAsString == "Lookup") {
                if (o.length - 1 == i) { temp += "'" + x.key + "LookupId':'" + x.value + "'"; }
                else { temp += "'" + x.key + "LookupId':'" + x.value + "',"; }
            }
            else {
                if (o.length - 1 == i) { temp += "'" + x.key + "':'" + x.value + "'"; }
                else { temp += "'" + x.key + "':'" + x.value + "',"; }
            }
        });
        temp += "}";
        const FA: IFileAttribute[] = this.eFields.map(
            (field: any) => (
                {
                    Id: field.Id, docId: field.listId, siteUrl: field.siteUrl,
                    InternalName: field.InternalName, LookupField: field.LookupField,
                    LookupList: field.LookupList, LookupWebId: field.LookupWebId,
                    PrimaryFieldId: field.PrimaryFieldId, StaticName: field.StaticName,
                    Title: field.Title, TypeAsString: field.TypeAsString, TypeDisplayName: field.TypeDisplayName,
                    ListId: field.ListId, CanBeDeleted: field.CanBeDeleted,
                    Choises: field.Choises, MaximumValue: field.MaximumValue, MinimumValue: field.MinimumValue
                }));
        isMail.Attributes = FA;

        if ((temp.length > 5) && (!this.isList)) {
            this.props.client
                .api(`https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag.split(',')[0]}/fields`)
                .patch(temp)
                .then(() => {
                    this.setState({ panelOpen: false, mbk: 'Success', mbkDisplay: true, mbMessage: "Mail and its content copied succefully" });
                })
                .catch(error => {
                    console.log('Error ', `https://graph.microsoft.com/v1.0/sites/${this._siteID}/lists/${this._documentName}/items/${etag.split(',')[0]}/fields`, ' ', error);
                });
        }
    }
    private loadNav(siteId: string, docName: string, path: string): void {
        const items: IBreadcrumbItem[] = [];
        this._documentName = docName;
        this._siteID = siteId;

        const links = path.substring(8, path.length).split("/");
        let counter = 0;
        links.map((url) => {
            counter > 1 &&
                items.push({
                    text: decodeURI(url),
                    key: counter.toString(),
                    onClick: () => {
                        this.isList = false;
                        this.confTitle = decodeURI(url); this.confUrl = path;
                        this.onInit2(Office.context);
                        this.openPanel(siteId, docName);
                    },
                    isCurrentItem: counter == links.length ? true : false,
                });
            counter++;
        });
        this.setState({ items: items });
    }
    private createMailFields(c?: boolean) {
        console.log('createMailfields', c);
        this.cmf = c;
    }
    public render(): React.ReactNode {
        const positioningContainerProps = {
            directionalHint: DirectionalHint.bottomCenter,
            doNotLayer: false,
        };
        return (
            <div style={{ paddingTop: 20 }}>
                <div className='ms-SPLegacyFabricBlock' >
                    <div className="ms-Grid" dir="ltr" >
                        <div className="ms-Grid-row" style={{ margin: 0, padding: 0 }}>
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}  >

                                <Stack horizontal styles={stackStyles}>
                                    <CommandBarButton styles={{ root: { height: 30, fontFamily: 'Tahoma', fontSize: FontSizes.small }, rootChecked: { border: 'inset 1px ' + theme.palette.blackTranslucent40, backgroundColor: '#E7F0DC', height: 30 }, icon: { color: 'red' } }}
                                        iconProps={{ iconName: 'MailAlert' }} checked={this.state.selection == 1}
                                        text="SaveTo"
                                        onClick={() => { this.setState({ selection: 1 }) }}
                                    />
                                    &nbsp;
                                    <CommandBarButton iconProps={{ iconName: 'Pinned' }} text="Locations"
                                        styles={{ root: { height: 30, fontFamily: 'Tahoma', fontSize: FontSizes.small }, rootChecked: { border: 'inset 1px ' + theme.palette.blackTranslucent40, backgroundColor: '#E7F0DC', height: 30 }, icon: { color: 'red' } }}
                                        checked={this.state.selection == 3}
                                        onClick={() => { this.setState({ selection: 3 }) }}
                                    />
                                    &nbsp;
                                    <CommandBarButton iconProps={{ iconName: 'TextDocumentShared' }} text="History"
                                        styles={{ root: { height: 30, fontFamily: 'Tahoma', fontSize: FontSizes.small }, rootChecked: { border: 'inset 1px ' + theme.palette.blackTranslucent40, backgroundColor: '#E7F0DC', height: 30 }, icon: { color: 'red' } }}
                                        checked={this.state.selection == 2}
                                        onClick={() => { this.setState({ selection: 2 }) }}
                                    />

                                </Stack>
                            </div>
                        </div>


                        <div className="ms-Grid-row" style={{ margin: 0, padding: 0 }}>
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, padding: 0 }}  >
                                <br />

                                <div style={this.state.mbkDisplay ? { display: 'block' } : { display: 'none' }}>
                                    <MessageBar
                                        messageBarType={this.state.mbk == "Success" ? MessageBarType.success : MessageBarType.error}
                                        isMultiline={false}
                                        // onDismiss={p.resetChoice}
                                        dismissButtonAriaLabel="Close"
                                        actions={
                                            <div>
                                                <MessageBarButton onClick={() => (this.setState({ mbkDisplay: false }))}>Close</MessageBarButton>
                                            </div>
                                        }
                                    >
                                        {this.state.mbk == "Success" ? <div>{this.state.mbMessage} </div> : <span>{this.state.mbMessage}</span>}
                                    </MessageBar>
                                </div>

                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, paddingTop: 0 }}  >

                                <div style={{ backgroundColor: "#f4f4f4", height: 40, textAlign: 'left' }} ref={this.targetButton}>
                                    {(this.state.selection === 1 || this.state.selection === 3) &&
                                        <Breadcrumb
                                            items={this.state.items}
                                            maxDisplayedItems={4}
                                            ariaLabel=""
                                            overflowAriaLabel="More links"
                                            overflowIndex={1}
                                            styles={breadStyles}
                                            onClick={() => { }}
                                        />
                                    }
                                    {this.state.isCoachmarkVisible && this.state.isFirstTime <= 1 && this.state.selection === 1 &&
                                        <Coachmark
                                            target={this.targetButton.current}
                                            positioningContainerProps={positioningContainerProps}
                                            ariaAlertText="A coachmark has appeared"
                                            ariaDescribedBy="coachmark-desc1"
                                            ariaLabelledBy="coachmark-label1"
                                            ariaDescribedByText="Press enter or alt + C to open the coachmark notification"
                                            ariaLabelledByText="Coachmark notification"
                                        >
                                            <TeachingBubbleContent
                                                headline="Select Destination"
                                                hasCloseButton
                                                closeButtonAriaLabel="Close"
                                                onDismiss={() => { this.setState({ isCoachmarkVisible: false }) }}
                                                ariaDescribedBy="Select Destination"
                                                ariaLabelledBy="Select Destination"
                                            >
                                                Here is the path of possible destinations.
                                            </TeachingBubbleContent>
                                        </Coachmark>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"  >
                                {this.state.mbk === 'Wait' && this.state.selection === 1 &&
                                    <Spinner size={SpinnerSize.medium} label={this.state.mbMessage} labelPosition="right" styles={{ root: { margin: 10 } }}></Spinner>
                                }
                                {this.state.selection === 1 &&
                                    <div style={{ fontStyle: 'italic', color: theme.palette.greenDark, textAlign: 'right', paddingRight: 20, paddingBottom: 5, paddingTop: 0 }}>{this.state.filesReady}</div>
                                }

                                {this.state.selection === 1 &&
                                    <Accordion style={{ width: '99%' }} multiple={false}>
                                        <AccordionItem value="1">
                                            <AccordionHeader style={{ backgroundColor: '#EEEDEB', fontSize: FontSizes.small, fontWeight: FontWeights.bold, color: theme.palette.themeDark, border: 'inset 1px ' + theme.palette.blackTranslucent40, marginBottom: 4 }} >Copy To OneDrive</AccordionHeader>
                                            <AccordionPanel>
                                                {this.state.loadSpinner && this.state.spninnerId == 'x1' &&
                                                    <Spinner size={SpinnerSize.large} />
                                                }
                                                {this.state.docs.map((item) => this.folderOneDrive(item, item.listName))}
                                            </AccordionPanel>
                                        </AccordionItem>
                                        <AccordionItem value="2">
                                            <AccordionHeader style={{ backgroundColor: '#EEEDEB', fontSize: FontSizes.small, fontWeight: FontWeights.bold, color: theme.palette.themeDark, border: 'inset 1px ' + theme.palette.blackTranslucent40, marginBottom: 4 }}>Copy To Teams </AccordionHeader>
                                            <AccordionPanel>

                                                {this.state.loadSpinner && this.state.spninnerId == 'x1' &&
                                                    <Spinner size={SpinnerSize.large} />
                                                }
                                                {this.state !== null && this.state !== undefined &&
                                                    this.state.teams.map(this.Teams)
                                                }
                                            </AccordionPanel>
                                        </AccordionItem>
                                        <AccordionItem value="3">
                                            <AccordionHeader style={{ backgroundColor: '#EEEDEB', fontSize: FontSizes.small, fontWeight: FontWeights.bold, color: theme.palette.themeDark, border: 'inset 1px ' + theme.palette.blackTranslucent40, marginBottom: 4 }}>Copy To SharePoint</AccordionHeader>
                                            <AccordionPanel>
                                                {this.state.loadSpinner && this.state.spninnerId == 'x3' &&
                                                    <Spinner size={SpinnerSize.large} />
                                                }
                                                {this.state != null && this.state.sites !== undefined && this.state.sites.map(this.sites)}
                                            </AccordionPanel>
                                        </AccordionItem>
                                    </Accordion>
                                }
                                {
                                    this.state.selection === 1 &&
                                    <div style={{ textAlign: 'right' }}> <Link styles={{ root: { paddingRight: 10, fontSize: FontSizes.small, color: theme.palette.red, fontWeight: FontWeights.semibold } }}
                                        onClick={() => { this.setState({ isAppFirstTime: !this.state.isAppFirstTime }); }}>Help</Link></div>
                                }
                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"   >
                                {this.state.isAppFirstTime && this.state.selection === 1 &&
                                    <FirstTime />
                                }

                            </div>
                        </div>

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"   >
                                <Panel
                                    headerTextProps={{ style: { color: theme.palette.themePrimary, fontSize: "medium" } }}
                                    isOpen={this.state.panelOpen}

                                    onDismiss={() => this.setState({ panelOpen: false })}
                                    headerText="Metadata properties"
                                    closeButtonAriaLabel="Close"
                                    onRenderFooterContent={this.onRenderFooterContent}
                                    headerClassName=""
                                    isFooterAtBottom={true}
                                >
                                    <FProperties isList={this.isList} createMailFields={this.createMailFields} path={this.confUrl} options={this.state.options} mailfrom={this.emailAddressFrom} entities={this.entities} fields={this.state.eFields} client={this.props.client} siteID={this._siteID} list={this._documentName} locTitle={this.confTitle} />
                                </Panel>
                                <Panel
                                    headerTextProps={{ style: { color: theme.palette.themePrimary, fontSize: "medium" } }}
                                    isOpen={this.state.panelTeam}
                                    onDismiss={() => this.setState({ panelTeam: false })}
                                    headerText="Send Mail To Teams"
                                    closeButtonAriaLabel="Close"
                                    onRenderFooterContent={this.onRenderFooterContentTeams}
                                    headerClassName=""
                                    isFooterAtBottom={true}>
                                    <TeamTag userEmai={Office.context.mailbox.userProfile.emailAddress} channelID={this._channelID} client={this.props.client} userOrTag={this.userOrTag} team={this.state.selectedTeam} />
                                </Panel>
                                <Panel
                                    headerTextProps={{ style: { color: theme.palette.themePrimary, fontSize: "medium" } }}
                                    isOpen={this.state.panelDocuments}
                                    onDismiss={() => this.setState({ panelDocuments: false })}
                                    headerText="Contained Documents"
                                    closeButtonAriaLabel="Close"
                                    onRenderFooterContent={this.onRenderFooterContentDocuments}
                                    headerClassName=""
                                    styles={{ root: { padding: 2, overflow: 'hidden' } }}
                                    isFooterAtBottom={true}>
                                    <ContainedDocs preview={this.preview} client={this.props.client} siteId={this._siteID} listName={this._documentName} eTag={this._eTag} />

                                </Panel>
                            </div>
                        </div>



                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, paddingTop: 0 }}  >
                                {this.state.selection === 2 &&

                                    <MailsFrom client={this.props.client} mailfrom={this.mails[0].sender} token={this.props.token} />

                                }

                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ margin: 0, paddingTop: 0 }}  >
                                {this.state.selection === 3 &&

                                    <Locations loadNav={this.loadNav} />

                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function generateGUID() {
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}


function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

